module.exports = __webpack_public_path__ + "3282dc7145ac02b9c3c03bdf61f601f8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mustache-glasses-s.png
// module id = 1861
// module chunks = 0